module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "forum-user"
  }, [(_vm.user) ? _c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h2', [_vm._v(_vm._s(_vm.user.firstName) + " " + _vm._s(_vm.user.lastName))])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "well clearfix"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('img', {
    attrs: {
      "src": _vm.user.avatar
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('h3', [_vm._v(_vm._s(_vm.user.firstName) + " " + _vm._s(_vm.user.lastName))]), _vm._v(" "), (_vm.user.title) ? _c('h4', [_vm._v("\n                        " + _vm._s(_vm.user.title) + "\n                    ")]) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.posts.length > 0),
      expression: "posts.length > 0"
    }],
    staticClass: "panel posts-panel"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('ul', {
    ref: "postList",
    staticClass: "post-list"
  }, _vm._l((_vm.posts), function(post) {
    return _c('li', {
      key: post.threadId + '_' + post.id
    }, [_c('ForumPostResult', {
      attrs: {
        "post": post,
        "thread": post.thread
      }
    }, [_c('template', {
      attrs: {
        "slot": "post-content"
      },
      slot: "post-content"
    }, [_c('div', {
      staticClass: "post-content-html",
      domProps: {
        "innerHTML": _vm._s(post.content)
      }
    })])], 2)], 1)
  })), _vm._v(" "), (!_vm.postList.hasMore()) ? _c('div', {
    staticClass: "after-posts-msg"
  }, [_vm._v("\n                That's all, folks!\n            ")]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h2', [_vm._v("Recent Posts")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-692edcd2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ForumUser.vue
// module id = 2038
// module chunks = 2